export const formatNumberShort = (value) => {
  const num = Number(value);

  if (num < 10000) {
    return num.toFixed(2);
  }

  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(1) + "B";
  }

  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1) + "M";
  }

  if (num >= 10_000) {
    return (num / 1_000).toFixed(1) + "k";
  }

  return num.toFixed(2);
};
